import FormText, { FormTextProps } from './FormText';

const FormNumber = (props: FormTextProps) => (
	<FormText
		{...props}
		type="number"
	/>
);

export default FormNumber;
